<p-toast></p-toast>
<p-dialog [(visible)]="isRejectPeriodicChangeRequestModal" [style]="{width: '40vw'}" (onHide)="cancel()" [modal]="true">

    <div *ngIf="errorMessages.length > 0">
        <p-messages severity="error">
          <ng-template pTemplate>
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-ml-2">{{errorMessageConstant}} </span>
            <ul>
              <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
            </ul>
          </ng-template>
        </p-messages>
      </div>
    <ng-template pTemplate="header">
        <b>Periodic Review Rejection</b>
    </ng-template>
    <div class="field">
        <span>
            {{periodicReviewCRIStaticMessageForModal}}
        </span>
    </div>
        <div class="field field-required">
            <bpt-datetime
              id="periodicReviewDateId"
              [(ngModel)]="reviewDate"
              placeholder="Enter or select a date"
              label="Periodic Review Date *"
              [minDate]="minDateValue.toString()"
            ></bpt-datetime>
          </div>
    
    <div class="field">
      <bpt-text-input [highlightAllOnFocus]="true" 
      [multiLine]="true" id="reviewerComment" label="Reviewer Comment (optional)" 
      [(ngModel)]="reviewerComment"></bpt-text-input>
    </div>

    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" id="confirm" (debounceClick)="confirmPeriodicChangeRequestRejection()"></p-button>
        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Cancel" id="cancel" (debounceClick)="cancel()"></p-button>
    </ng-template>
</p-dialog>
